module.exports = __webpack_public_path__ + "static/media/eliza-jane-lesb.78da0c2c.jpg";